import auth from '../../auth/authService';
import { PlatformsOptions } from '@/modules/library/constants';

export const apiDomain = auth.audience.replace(/\/$/, ''); // Remove trailing slashes from the audience
// export const apiDomain = 'http://localhost:4443';

export const myJigsV2Url = apiDomain + '/v2/me/jigs';
export const jigsV1Url = apiDomain + '/jigs/v1';
export const jigsV2Url = `${apiDomain}/jigs/v2`
export const meJigsV2Url = `${apiDomain}/me/jigs/v2`
export const jigMetadataV1 = 'metadata/v1'
export const myJigsV2UrlMetrics = apiDomain + '/v2/me/jigs/metrics';
export const publicModelsUrl = apiDomain + '/library';
export const myJigsUrl = apiDomain + '/me/jigs';
export const libraryCategoriesUrl = apiDomain + '/library/categories';
export const libraryCategoryStatesUrl = libraryCategoriesUrl + '/states';
export const tenantsV1Url = apiDomain + '/tenants/v1';
export const tenantsJigsUrl = '/jigs/v2';
export const tenantsImagesV1Url = tenantsV1Url + '/images/v1';
export const usersV1Url = apiDomain + '/users/v1';
export const statisticsUrl = apiDomain + '/statistics/reports';
export const billingUrl = apiDomain + '/billing';
export const checkoutUrl = `${billingUrl}/stripe/create-checkout-session`
export const tenantSetupJobsUrl = apiDomain + '/tenant-setup-jobs/v1';
export const completedTenantSetupJobsUrl = apiDomain + '/secure-tenant-setup-jobs/v1/completed';
export const sendEmailVerificationUrl = apiDomain + '/auth0-public/send-email-verify/v1';
export const versionUrl = apiDomain + '/version/latest';
export const hubSpotVisitorIdTokenUrl = apiDomain + '/hs/v1/visitoridtoken';
export const createNewVersionUrl = `${apiDomain}/version`;
export const getSmallQRCodeUrl = '/qrcode/v1/small/v1';
export const getLargeQRCodeUrl = '/qrcode/v1/large/v1';

export const communitySlackWebhook = auth.slackWebhook;
export const hubspotId = auth.hubspotId;

export const createStripeCheckoutUrl = apiDomain + '/billing/stripe/create-checkout-session';
export const createStripeCustomerPortalUrl = apiDomain + '/billing/stripe/create-customer-portal-session';

export const branchIODownloadUrlsV1 = apiDomain + '/branchio/link-download-urls/v1'

export const dynaconfConfig = `${apiDomain}/configs/v1`

export const loadingMutationName = 'app/changeLoadingState';
export const loadingModalMutationName = 'app/changeModalLoadingState';
export const isStatisticsLoadingMutationName = 'app/changeIsStatisticsLoadingState';
export const CustomHeaderKeyTenantId = 'X-Jig-Tenant-Id';
export const SetApiErrorMutationName = 'app/setApiError';
export const passwordMinLength = 8;
export const versionErrorName = 'getting latest version details'

export const helpHeroJigCountKey = 'jigCount';
export const helpHeroModelsCountKey = 'modelsCount';
export const helpHeroTenantUsersCountKey = 'tenantUsersCount';
export const helpHeroTenantLogoUrlKey = 'tenantLogoUrl';

export const teamPermissionView = 'view';
export const teamPermissionReshare = 'sharable-readonly';

export const subscriptionTierFree = 'free'
export const subscriptionTierTeam = 'team'
export const subscriptionTierOrganization = 'organization'
export const subscriptionTiers = [subscriptionTierFree, subscriptionTierTeam, subscriptionTierOrganization]
export const ManagedByTypeTeamManager = 'team_manager'
export const ManagedByTypeJigStaff = 'jig_staff'
export const subscriptionManagedByTypes = [
  {
    value: ManagedByTypeTeamManager,
    text: 'Team manager',
  },
  {
    value: ManagedByTypeJigStaff,
    text: 'Jig staff',
  }
];
export const pricingSet_2020_01 = 'set_2020_01';
export const pricingSet_2022_07 = 'set_2022_07';
export const pricingSet_2023_02 = 'set_2023_02';
export const pricingSet_2023_06 = 'set_2023_06';
export const pricingSets = [pricingSet_2020_01, pricingSet_2022_07, pricingSet_2023_02, pricingSet_2023_06];
export const defaultSeatsIncludedInTier = '-';
export const defaultMaxJigsInTier = 0;
export const defaultMaxJigsPerInTier = '-';
export const embedQueryParamDefaultLang = 'en-US';

export const eventLabel = 'target-properties';

export const userAvatarColors = ['dune-100', 'rain-700', 'info-500', 'info-300'];

export const appDownloadDeeplinks = {
  jigspace: [
    {
      platform: PlatformsOptions.desktop,
      variant: 'macos',
      nonProdDeeplinkUrl: 'https://link.jig.space/e/integration-test-dummy-link',
    },
    {
      platform: PlatformsOptions.desktop,
      variant: 'win',
      nonProdDeeplinkUrl: 'https://link.jig.space/e/integration-test-dummy-link',
    },
    {
      platform: PlatformsOptions.desktop,
      variant: 'win-zip',
      nonProdDeeplinkUrl: 'https://link.jig.space/e/integration-test-dummy-link',
    },
  ],
};

export const jigVisibilityPublic = 'public';
export const jigVisibilityLink = 'link';
export const jigVisibilityPrivate = 'private';
export const jigVisibilityPassword = 'link-password';
export const jigVisibilities = {
  [jigVisibilityPublic]: 'Public sharing',
  [jigVisibilityLink]: 'Anyone with link can view',
  [jigVisibilityPrivate]: 'Private (Invite only)',
  [jigVisibilityPassword]: 'Password protected',
};

export const copyableByOwner = 'owner_user'
export const copyableByAnyone = 'anyone'
export const copyableByTenant = 'owner_tenant'
export const copyableByList = [
  { value: copyableByAnyone, copy: 'Anyone can copy', disabled: false },
  { value: copyableByTenant, copy: 'Team only', disabled: true },
]

export const defaultTenantsPagination = {
  page: 1,
  limit: 10,
  name: '',
}

export const nonSystemErrors = {
  conflict: {
    status: 409,
    copy: '',
  },
  unprocessableEntity: {
    status: 422,
    copy: `Oops, the Jig has been updated by another more recent session and your changes cannot be saved. Refresh to see the latest version.`,
  }
}

// Match all non-printable characters but except '\n', '\r', '\t', '\b', '\f' characters.
export const nonPrintableCopyRegex = new RegExp(/(?:(?![\n\r\t\b\f])[\p{Cc}]+|\\u([0-9a-fA-F]{4}))/gu)

export const AVPFullAccessFeatureGate = 'ViewingGate_MAR_2024'
export const AVPFeaturePullApartKey = 'AVP_Feature_PullApart'
